import React from 'react';
import { cx } from '@emotion/css';
import { ix } from '../../../../../../utils/ix';
import { SearchField } from '../../../../formFields';
import { Typography } from '../../../../../electrons';
import useStyles from './EventSelectorCard.styles';
import { Card, CardContent } from '@mui/material';
import { MetricSelectorColumn } from '../MetricSelectorColumn';
import EventSelectorCardItem from './components/EventSelectorCardItem';
import * as Constants from '../MetricSelectorColumn/MetricSelectorColumn.constants';
import { CUSTOM_METRICS_NAME } from '../MetricSelectorColumn/MetricSelectorColumn.constants';
export const EventSelectorCard = (props) => {
    var _a, _b, _c;
    const [isScrolled, setIsScrolled] = React.useState(false);
    const eventsRef = React.useRef(null);
    const classes = useStyles();
    const [search, setSearch] = React.useState('');
    const handleEventsSearch = (event) => {
        setSearch(event.target.value);
    };
    const handleScroll = (e) => {
        const target = e.target;
        const shouldShowScrollShadow = target.scrollTop > 30;
        if (isScrolled !== shouldShowScrollShadow) {
            setIsScrolled(shouldShowScrollShadow);
        }
    };
    const getSortedEvents = (events) => {
        return events
            .filter((event) => event.name.toLowerCase().includes(search.toLowerCase()))
            .filter((event) => event.name !== CUSTOM_METRICS_NAME)
            .sort((a, b) => {
            const aPinned = props.pinnedEvents.includes(a.name);
            const bPinned = props.pinnedEvents.includes(b.name);
            if (aPinned !== bPinned) {
                return aPinned ? -1 : 1;
            }
            if (a.order !== undefined && b.order === undefined) {
                return -1;
            }
            if (a.order === undefined && b.order !== undefined) {
                return 1;
            }
            if (a.order !== undefined && b.order !== undefined) {
                return a.order - b.order;
            }
            return a.name.localeCompare(b.name);
        });
    };
    const customMetricsEvent = React.useMemo(() => {
        let foundMetric = {
            name: 'Custom Metrics',
            columns: [],
        };
        for (const group of props.groups) {
            for (const event of group.events) {
                if (event.name === Constants.CUSTOM_METRICS_NAME) {
                    foundMetric = event;
                }
            }
        }
        return foundMetric;
    }, [props.groups]);
    return (React.createElement(Card, { className: classes.root },
        React.createElement(Typography, { id: "card-title", className: classes.header, variant: "h4", color: "inherit" }, "Metrics"),
        React.createElement(CardContent, { className: classes.content },
            React.createElement("div", { className: classes.eventsWrapper },
                React.createElement("div", { className: classes.eventsFilter },
                    React.createElement(SearchField, { id: "search_events", placeholder: `Search events`, value: search, onChange: handleEventsSearch, fullWidth: true })),
                React.createElement("div", { className: cx(classes.titleShadow, {
                        [classes.titleShadowShow]: isScrolled,
                    }) }),
                React.createElement("div", { className: classes.events, ref: eventsRef, onScroll: handleScroll, id: "events-selector-list" }, props.groups.map((group) => (React.createElement("div", { id: ix(props.id), key: group.name },
                    React.createElement("h3", { className: classes.title }, group.name),
                    React.createElement("div", null, getSortedEvents(group.events).map((event) => {
                        var _a;
                        return (React.createElement(EventSelectorCardItem, { key: `item-${group.name}-${event.name}`, selected: event.name === ((_a = props.selected) === null || _a === void 0 ? void 0 : _a.name), event: event, onItemClick: props.onSelectEvent, onItemPin: props.onEventPin, onItemUnpin: props.onEventUnpin, pinned: props.pinnedEvents.includes(event.name) }));
                    })))))),
                React.createElement("div", { className: classes.customMetricsButton },
                    React.createElement(EventSelectorCardItem, { event: customMetricsEvent, selected: ((_a = props.selected) === null || _a === void 0 ? void 0 : _a.name) === Constants.CUSTOM_METRICS_NAME, onItemClick: () => props.onSelectEvent(customMetricsEvent), onItemPin: () => { }, onItemUnpin: () => { } }))),
            React.createElement("div", { className: classes.metrics, id: "metrics-selector-list" },
                React.createElement(MetricSelectorColumn, { selectedMetrics: props.selectedMetrics, eventName: (_b = props.selected) === null || _b === void 0 ? void 0 : _b.name, columns: ((_c = props.selected) === null || _c === void 0 ? void 0 : _c.columns) || [], onItemSelect: props.onSelectMetric, onItemDeselect: props.onDeselectMetric, onAddCustomMetric: props.onAddCustomMetric, onItemEdit: props.onItemEdit })))));
};
//# sourceMappingURL=EventSelectorCard.js.map